<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="schedules"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :sort="sort"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="mr-3">Расписание отчетов</h1>
        <button @click="edit()" class="btn btn-outline-secondary btn-sm mr-auto" v-show="selected && selected.length">
          Редактировать выбранные
          <span class="badge badge-dark">{{ selected.length }}</span>
        </button>
        <btn-filters
          :data="data"
          endpoint="schedules"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @sort-change="sortChange"
        @selection-change="(selection) => {this.selected = selection}"
      >
        <table-column-serial-number sortable="keyword"/>
        <el-table-column align="center" type="selection"/>
        <el-table-column sortable="keyword" prop="address" label="Адрес установки" min-width="100" :show-overflow-tooltip="true"/>
        <el-table-column prop="reports_schedule" label="Расписание">
          <template slot-scope="{row}">
            <reports-schedule :id="row.id" v-model="row.reports_schedule"></reports-schedule>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import { map, isEqual } from 'lodash'
  import ReportsScheduleEditModal from '../../components/reports-schedule-edit-modal.vue'

  export default {
    metaInfo: {title: 'Расписание отчетов'},
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        selected: [],
        sort: null,
      }
    },
    methods: {
      getScheduleForSelected () {
        const sameSchedule = map(this.selected, 'reports_schedule').every((schedule, index, schedules) => {
          if (index === 0) return true
          const previous = schedules[index - 1]
          return isEqual(schedule, previous)
        })

        return sameSchedule ? this.selected[0].reports_schedule : {}
      },
      edit () {
        const ids = map(this.selected, 'id')
        const value = this.getScheduleForSelected()

        this.$root
          .showModal(ReportsScheduleEditModal, {ids, value})
          .then((newSchedule) => {
            newSchedule && this.selected.forEach((machine) => {
              machine.reports_schedule = newSchedule
            })
          })
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const keyword = sort.column.sortable === 'keyword' ? '.keyword' : ''
          this.sort = `${sort.prop + keyword}:${order}`
        } else {
          this.$emit('update:sort', null)
        }
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/schedule.vue